export const PAYMENT_SOURCE = {
  STRIPE: 'STRIPE',
  SALESFORCE: 'SALESFORCE',
  CARD: 'CARD',
  CARD_PRESENT: 'CARD_PRESENT',
};
export const PAYMENT_STATUS = {
  SUCCEEDED: 'Succeeded',
  PENDING: 'Pending',
  FAILED: 'Failed',
  RECEIVED: 'Received',
  VOID: 'Void',
};
export const PAYMENT_METHOD = {
  ACH: 'ACH',
  CARD: 'Card',
};
export const PAYMENT_TYPE = {
  PAYMENT: 'Payment',
  REFUND: 'Refund',
  CHARGEBACK: 'Chargeback',
};
export const PAYMENT_REASON = {
  DEPOSIT: 'Deposit',
  CHECK: 'Check',
};
